import Chunk from "./Chunk";

export default class MattChunk extends Chunk {
  // Not implemented yet
}
